import InstagramIcon from "@mui/icons-material/Instagram";
import TelegramIcon from "@mui/icons-material/Telegram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";

export const socialMedias = [
  {
    id: 3423451,
    icon: <InstagramIcon />,
    link: "https://abdullokh.netlify.app/",
  },
  {
    id: 3423452,
    icon: <TelegramIcon />,
    link: "https://abdullokh.netlify.app/",
  },
  {
    id: 3423453,
    icon: <FacebookIcon />,
    link: "https://abdullokh.netlify.app/",
  },
  {
    id: 3423454,
    icon: <YouTubeIcon />,
    link: "https://abdullokh.netlify.app/",
  },
];
